export const videoGallery = () => {
  $('.video-thumb').each(function () {
    const videoSrc = $(this).find('iframe').attr('src');
    $(this).attr('data-video', videoSrc);
    console.log(videoSrc);
  });
  $('.video-gallery').on(
    'click',
    '.video-thumb:not(.main-video)',
    function (e) {
      e.stopPropagation();
      const videoSrc = $(this).attr('data-video') + '&autoplay=1';
      const resetSrc = $('.main-video').attr('data-video');
      $('.main-video')
        .removeClass('main-video')
        .addClass('video-thumb')
        .find('iframe')
        .attr('src', resetSrc);
      $(this).addClass('main-video').find('iframe').attr('src', videoSrc);
    },
  );
};
